import { useEffect, useState } from 'react';
import {
  categoriesMapping,
  categoryLogos,
  convertAmoutToINRWithNotation,
  formatToINR,
  groupByCategory,
} from '../../../../../Utils/utils';
import {
  ArrowDownOutlined,
  LeftOutlined,
  RightOutlined,
  SwapOutlined,
} from '@ant-design/icons';
import { Typography, Divider, Flex } from 'antd';
import { logoBaseURL } from '../../../../../Utils/constants';
import styles from './index.module.css';
import dayjs from 'dayjs';
enum flowType {
  CREDIT,
  DEBIT,
}
const CategoryAnalysis: React.FC<{ setViewAll: any }> = ({ setViewAll }) => {
  const [categorisedData, setCategoriesData] = useState(groupByCategory());
  const [currentFlow, setCurrentFlow] = useState('CREDIT');
  const [currentCategory, setCurrentCategory] = useState<
    { key: string; txnArray: any } | undefined
  >(undefined);
  const [isExpanded, setIsExpanded] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const showSpecificCategoryItems = () => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',

          padding: '0 24px',
        }}
      >
        <div
          style={{
            padding: '16px 0',
            position: 'sticky',
            top: 0,
            background: '#f8f9fa',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Typography.Text
            style={{
              fontSize: 16,

              color: 'grey',
              fontWeight: 500,
            }}
          >
            <LeftOutlined
              onClick={() => setIsExpanded(false)}
              style={{ marginRight: 3 }}
            />
            {categoriesMapping[currentCategory!.key]}
          </Typography.Text>
          <Typography.Text style={{ fontSize: 24, marginLeft: 20 }}>
            {formatToINR(currentCategory?.txnArray.amount.toString())}
          </Typography.Text>
        </div>
        <div
          style={{
            background: '#fff',
            marginTop: 15,
            borderRadius: 16,
          }}
        >
          {(currentCategory?.txnArray.transactions).map((transaction: any) => {
            return (
              <div
                style={{
                  display: 'flex',
                  padding: 10,
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <div
                  style={{
                    display: 'flex',

                    alignItems: 'center',
                  }}
                >
                  <div className={styles.image_container}>
                    <img
                      src={logoBaseURL + transaction.merchantLogoCode + '.jpg'}
                      height={25}
                      style={{ objectFit: 'contain' }}
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src =
                          logoBaseURL +
                          'f7080c52-607c-46b3-8263-112cefcd5dae.jpg';
                      }}
                    />
                  </div>
                  <div>
                    <Typography.Text>{transaction.displayName}</Typography.Text>
                    <br />
                    <Typography.Text>
                      on{' '}
                      {dayjs(transaction.dateOfTransaction).format(
                        'DD MMM YYYY'
                      )}
                    </Typography.Text>
                  </div>
                </div>

                <Typography.Text>
                  {formatToINR(transaction.amount)}
                </Typography.Text>
              </div>
            );
          })}
        </div>
      </div>
    );
  };
  const showItems = () => {
    const txnArray =
      currentFlow === 'CREDIT' ? categorisedData.CREDIT : categorisedData.DEBIT;

    return (
      <div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: 16,
            position: 'sticky',
            top: 0,
            background: '#f8f9fa',
          }}
        >
          <Typography.Text
            style={{
              fontSize: 18,
              fontWeight: 600,
              display: 'flex',
              alignItems: 'center',
              gap: 5,
            }}
          >
            <LeftOutlined onClick={setViewAll} />
            Category Analysis
          </Typography.Text>
          <div
            style={{
              padding: '10px',
              background: '#0460ff',
              borderRadius: '12px',
              cursor: 'pointer',
            }}
            onClick={() => {
              if (currentFlow === 'CREDIT') {
                setCurrentFlow('DEBIT');
              } else {
                setCurrentFlow('CREDIT');
              }
            }}
          >
            <SwapOutlined style={{ color: '#fff', marginRight: 5 }} />
            <Typography.Text style={{ color: '#fff' }}>
              {currentFlow}
            </Typography.Text>
          </div>
        </div>
        <div
          style={{
            background: 'white',
            borderRadius: '16px',
            margin: '16px',
          }}
        >
          {Object.keys(txnArray).map((key: any, i: number) => {
            return (
              <div>
                <div
                  onClick={() => {
                    setCurrentCategory({ key, txnArray: txnArray[key] });
                    setIsExpanded(true);
                  }}
                  style={{
                    padding: 10,
                    cursor: 'pointer',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      cursor: 'pointer',
                    }}
                  >
                    <div className={styles.image_container}>
                      <img
                        src={logoBaseURL + categoryLogos[key] + '.jpg'}
                        height={25}
                        style={{ objectFit: 'contain' }}
                        onError={({ currentTarget }) => {
                          currentTarget.onerror = null; // prevents looping
                          currentTarget.src =
                            logoBaseURL +
                            'f7080c52-607c-46b3-8263-112cefcd5dae.jpg';
                        }}
                      />
                    </div>

                    <Typography.Text>{categoriesMapping[key]}</Typography.Text>
                  </div>
                  <Typography.Text
                    style={{
                      display: 'flex',
                      gap: 8,
                    }}
                  >
                    {formatToINR(txnArray[key].amount.toString())}
                    <RightOutlined />
                  </Typography.Text>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };
  return <>{isExpanded ? showSpecificCategoryItems() : showItems()}</>;
};

export default CategoryAnalysis;
